<!-- Drag & Drop Group Container -->
<div cdkDropListGroup>
  @for (group of splitItemsTemplateData(); track group.category.value) {
    <div class="card card-sm border-secondary mb-3">
      <div class="card-body">
        <div class="row align-items-center mb-3">
          <div class="col">
            <div class="fw-medium mb-0">
              {{ group.category.name }}
              @if (group.category.account_code) {
                ({{ group.category.account_code }})
              }
            </div>
            @if (categoryErrorsByValue().get(group.category.value)) {
              <div class="invalid-feedback d-block">
                @for (error of categoryErrorsByValue().get(group.category.value); track $index) {
                  <div>{{ error }}</div>
                }
              </div>
            }
          </div>
          <div class="col-auto ms-auto">
            Sub total: {{ group.subtotal | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
          </div>
          <div class="col-auto">
            <button
              type="button"
              class="btn-action text-danger"
              (click)="onDeleteCategory(group.category)"
              title="Delete category and all items">
              <i class="pays-icon ic-bin size-1"></i>
            </button>
          </div>
        </div>

        <!-- Drop Zone for this category -->
        <div
          cdkDropList
          [cdkDropListData]="group.items"
          [id]="'category-' + group.category.value"
          (cdkDropListDropped)="drop($event, group.category.value)"
          class="item-drop-zone"
          [class.empty-drop-zone]="group.items.length === 0">
          @for (item of group.items; track $any(item)._trackingId) {
            <div
              cdkDrag
              class="draggable-item bg-pays-subtle">
              <div class="row gx-2 flex-nowrap">
                <div class="col">
                  <app-transaction-split-item
                    [preferredTaxRateId]="group.category.tax_id"
                    [item]="item"
                    [itemIndex]="$index"
                    [itemId]="$any(item)._trackingId"
                    [itemError]="itemErrorsByIndex().get($any(item)._trackingId) ?? null"
                    (itemChange)="onItemChange($event, group.category.value, $index)"
                    (clearFieldError)="onClearFieldError($any(item)._trackingId, $event.field)">
                  </app-transaction-split-item>
                </div>
                <div class="col-auto">
                  <div class="row gx-1 flex-nowrap pt-1">
                    <div class="col">
                      <button
                        type="button"
                        class="btn-action"
                        (click)="onDeleteItem($index, group.category.value)"
                        title="Delete item">
                        <i class="pays-icon ic-bin size-075"></i>
                      </button>
                    </div>
                    <div class="col ps-0">
                      <button
                        type="button"
                        cdkDragHandle
                        class="btn-action drag-handle"
                        title="Drag to move">
                        <i class="iconoir-arrow-separate-vertical size-075"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- Empty state message -->
          @if (group.items.length === 0) {
            <div class="empty-state">
              <div class="row justify-content-center align-items-center">
                <div class="col-auto">
                  <i class="iconoir-arrow-down fs-5"></i>
                </div>
                <div class="col-auto text-muted">Drop items here or click "Add Line Item"</div>
              </div>
            </div>
          }
        </div>

        <div class="text-end">
          <button
            type="button"
            class="btn btn-sm btn-light-on-white text-secondary mt-2"
            (click)="addNewItem(group.category.value)">
            <i class="iconoir-plus-circle"></i> Add new item
          </button>
        </div>
      </div>
    </div>
  }
</div>
